import React from "react";
import "assets/scss/components/profileCard.scss";

const DISCIPLINE_ORDER = ["CWT", "DYN", "STA", "CNF", "FIM", "DNF"];

const sortRecords = (records) => {
    if (!Array.isArray(records)) return [];
    return [...records].sort((a, b) => {
        const ai = DISCIPLINE_ORDER.indexOf(a.discipline);
        const bi = DISCIPLINE_ORDER.indexOf(b.discipline);
        return (ai < 0 ? 99 : ai) - (bi < 0 ? 99 : bi);
    });
};

const formatRecord = (r) => {
    if (r.value_display) {
        const isSec = r.discipline === "STA";
        return isSec
            ? { value: r.value_display, sub: null }
            : { value: r.value_display.replace(/m$/, ""), sub: "m" };
    }
    if (r.value_seconds != null) {
        return { value: String(r.value_seconds), sub: null };
    }
    const num = Number(r.value_meters);
    return {
        value: Number.isFinite(num) ? num.toFixed(1) : r.value_meters,
        sub: "m",
    };
};

/**
 * 종목별 PB 그리드. 커뮤니티 프로필 카드와 동일한 시안 B v2 레이아웃.
 */
const PbRecordGrid = ({ records, max = 6 }) => {
    if (!records || records.length === 0) return null;
    const sorted = sortRecords(records).slice(0, max);
    const cols = Math.min(sorted.length, 3);
    return (
        <div className="profile-card__pb">
            <div className="profile-card__pb-header">
                <span className="profile-card__pb-title">PERSONAL BEST</span>
            </div>
            <div
                className="profile-card__pb-grid"
                style={{ gridTemplateColumns: `repeat(${cols}, 1fr)` }}
            >
                {sorted.map((r, i) => {
                    const f = formatRecord(r);
                    const col = i % cols;
                    const row = Math.floor(i / cols);
                    return (
                        <div
                            key={r.discipline}
                            className="profile-card__pb-cell"
                            style={{
                                borderLeft: col > 0 ? "1px solid #ededed" : "none",
                                borderTop: row > 0 ? "1px solid #ededed" : "none",
                            }}
                        >
                            <div className="profile-card__pb-label">{r.discipline}</div>
                            <div className="profile-card__pb-value-row">
                                <span className="profile-card__pb-value tnum">
                                    {f.value ?? "—"}
                                </span>
                                {f.sub && f.value != null && (
                                    <span className="profile-card__pb-sub">{f.sub}</span>
                                )}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default PbRecordGrid;
